// import React from "react";
// import Header from "./Header";
// import HeaderNavigation from "../pages/header";
// import Footer from "../pages/footer";
import StockTicker from "./Ticker";
// export default function Layout({ children }) {
//   return (
//     <>
//       <StockTicker />

//       <HeaderNavigation />
//       {children}
//       <Footer />
//     </>
//   );
// }

import React from "react";
import { useLocation } from "react-router-dom";
import HeaderNavigation from "../pages/header";
import Footer from "../pages/footer";

// StockTicker removed — it was rendering as a fixed empty gray bar
// (its data fetch was commented out). The PSXTicker on the home page
// still works fine — it lives inside new-home/index.js independently.

// Full-bleed routes: content fills the viewport below the header,
// no footer, no page scroll (e.g. the real-time TradingView chart).
const FULL_BLEED_ROUTES = ["/chart-view"];

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const isFullBleed = FULL_BLEED_ROUTES.some(
    (r) => pathname === r || pathname.startsWith(r + "/")
  );

  return (
    <>
     {/* <StockTicker /> */}
      <HeaderNavigation />

      {/* hdr-offset pushes content below the two fixed header bands.
          hdr-offset--full makes the page exactly viewport height (no scroll). */}
      <div className={`hdr-offset${isFullBleed ? " hdr-offset--full" : ""}`}>
        {children}
      </div>

      {!isFullBleed && <Footer />}
    </>
  );
}